import { ActionType } from 'cio/models/action';

type Description = {
  [key in ActionType]?: string;
};

export type DeliveryState = {
  state: string;
  description: string | Description;
  classNames: string;
  label?: string;
};

export default Object.freeze(<DeliveryState[]>[
  {
    state: 'unsubscribed',
    description: 'Recipient unsubscribed from future messages',
    classNames: 'is-error',
  },
  {
    state: 'topic_unsubscribed',
    description: 'Recipient unsubscribed from the message topic',
    classNames: 'is-error',
    label: 'Topic Unsubscribes',
  },
  {
    state: 'converted',
    description: 'Recipient completed the goal for the campaign',
    classNames: 'is-success',
  },
  {
    state: 'spammed',
    description: 'Recipient marked message as spam',
    classNames: 'is-error',
  },
  {
    state: 'clicked',
    description: 'Recipient clicked on a tracked link in the message',
    classNames: 'is-success',
  },
  {
    state: 'opened',
    description: 'Recipient opened the message',
    classNames: 'is-success',
  },
  {
    state: 'suppressed',
    description: 'Not delivered because a previous message to recipient bounced or was marked as spam',
    classNames: 'is-pending',
  },
  {
    state: 'bounced',
    description: "Not delivered because recipient's address is invalid or temporarily unavailable",
    classNames: 'is-pending',
  },
  {
    state: 'sent',
    description: 'Successfully sent to delivery provider',
    classNames: 'is-success',
  },
  {
    state: 'delivered',
    description: {
      push_action: 'We received confirmation from the device that the message was received',
      twilio_action: "We received confirmation from Twilio that the message was sent to the recipient's phone carrier",
      email_action:
        "We received confirmation from the delivery provider that an email was sent to the recipient's email service provider (ESP)",
    },
    classNames: 'is-success',
  },
  {
    state: 'failed',
    description: 'This message failed to reach the delivery provider and was not sent',
    classNames: 'is-error',
  },
  {
    state: 'undeliverable',
    description: 'We did not attempt to send this message. Expand the delivery to see what prevented sending.',
    classNames: 'is-error',
  },
  {
    state: 'deferred',
    description: 'This message is deferred to be sent later',
    classNames: 'is-pending',
  },
  {
    state: 'drafted',
    description: 'Ready to be sent with your approval',
    classNames: 'is-warning',
  },
  {
    state: 'attempted',
    description: "We've attempted to send this but weren't successful. Retrying…",
    classNames: 'is-warning',
  },
  {
    state: 'queued',
    description: 'This message has been queued and will be sent soon',
    classNames: '',
  },
  {
    state: 'holdout',
    description: "This message is a holdout test and won't be delivered to any recipients",
    classNames: '',
  },
]);
